class WebAuthStorage {
    async setItem(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            console.error('WebAuthStorage setItem failed:', error);
        }
    }
    async getItem(key) {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            console.error('WebAuthStorage getItem failed:', error);
            return null;
        }
    }
    async removeItem(key) {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('WebAuthStorage removeItem failed:', error);
        }
    }
    async clear() {
        try {
            // Clear only items with our prefix
            const keysToRemove = [];
            for(let i = 0; i < localStorage.length; i++){
                const key = localStorage.key(i);
                if (key && key.startsWith(this.prefix)) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach((key)=>localStorage.removeItem(key));
        } catch (error) {
            console.error('WebAuthStorage clear failed:', error);
        }
    }
    getAllValues() {
        try {
            const values = [];
            for(let i = 0; i < localStorage.length; i++){
                const key = localStorage.key(i);
                if (key && key.startsWith(this.prefix)) {
                    const cleanKey = key.substring(this.prefix.length);
                    const value = localStorage.getItem(key);
                    values.push({
                        key: cleanKey,
                        value
                    });
                }
            }
            return values;
        } catch (error) {
            console.error('WebAuthStorage getAllValues failed:', error);
            return [];
        }
    }
    constructor(options){
        this.prefix = `${options.name}:`;
    }
}

export { WebAuthStorage };
//# sourceMappingURL=WebStorage.js.map
